<template>
    <div class="modal" v-bind:class="{ 'show': showModal }" v-on:click="onClose($event)">
        <div class="modal-content">
            <header>{{ title }}
              <template v-if="showRefreshButton">
                <div style="width:150px;margin-right:10px;float:right;clear:both">
  
                  <button title="Refresh" style="margin-top:0px;padding:3px;padding-left:5px;padding-right:5px" v-on:click="reloadLocation()">Refresh manually
                  </button>
                </div>
              </template>
              <span title="Close"></span></header>
            <article>
                <slot></slot>
            </article>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                required: true
            },
            showRefreshButton:
                {
                  type: Boolean,
                  required: false
                }
                , 
            formValue: { 
                type: Object,
                required: false
            }
        },
        data: () => ({
            showModal: false
        }),
        mounted: function()
        {
          if (!this.showRefreshButton)
            return;
          
          const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
          });

          let value = params.showModal; // "some_value"
          
          if (value === undefined || value === null || this.showModal)
          {
             return;
          }
          
          this.showModal = true;
        }
        ,
        methods: {
            reloadLocation() {
              let presentUrl = window.location.href;
              let delimiter = presentUrl.includes("?") ? "&" : "?";
              let newUrl = presentUrl + delimiter + "showModal=true";
              window.location.replace(newUrl);
            },
            onClose(e) {
                if(e.target.classList.contains("modal") || e.target.tagName == "SPAN")
                    this.showModal = false
            },
            show() {
                this.showModal = true
            },
            hide() {
                this.showModal = false
            }
        }
    }
</script>